export const siteUrl = (import.meta.env.VITE_SITE_URL || 'https://usfanslink.makeup').replace(/\/+$/, '');

export const siteName = 'USFans Spreadsheet';

export const siteDescription =
  'Discover practical USFans spreadsheet resources, creator guides, comparisons, safety information and helpful tools designed to make creator research faster, clearer and easier to organize.';

export const siteLogo =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg';